import {Grid, Typography} from '@mui/material';

interface Props {
  text: string;
}
export default function PageHeader({text}: Props) {
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: {xs: '0px', sm: '16px'},
        marginBottom: 4,
      }}
    >
      <Grid item>
        <Typography variant='h1'>{text}</Typography>
      </Grid>
    </Grid>
  );
}
